import { apiClient } from './apiClient'

export interface FAQ {
  Id: string
  Question: string
  Answer: string
  Order: number
  IsActive: boolean
  CreatedAt: string
  UpdatedAt?: string
}

export interface CreateFAQRequest {
  Question: string
  Answer: string
  Order: number
  IsActive: boolean
}

export interface UpdateFAQRequest {
  Question: string
  Answer: string
  Order: number
  IsActive: boolean
}

class FAQApiService {
  /**
   * Get all active FAQs (public endpoint)
   */
  async getActiveFAQs(): Promise<FAQ[]> {
    const response = await apiClient.get<FAQ[]>('/faqs')
    return response.data
  }

  /**
   * Get FAQ by ID (public endpoint)
   */
  async getFAQById(id: string): Promise<FAQ> {
    const response = await apiClient.get<FAQ>(`/faqs/${id}`)
    return response.data
  }

  /**
   * Get all FAQs including inactive (admin endpoint)
   */
  async getAllFAQs(): Promise<FAQ[]> {
    const response = await apiClient.get<FAQ[]>('/admin/faqs')
    return response.data
  }

  /**
   * Create new FAQ (admin endpoint)
   */
  async createFAQ(request: CreateFAQRequest): Promise<FAQ> {
    const response = await apiClient.post<FAQ>('/admin/faqs', request)
    return response.data
  }

  /**
   * Update FAQ (admin endpoint)
   */
  async updateFAQ(id: string, request: UpdateFAQRequest): Promise<FAQ> {
    const response = await apiClient.put<FAQ>(`/admin/faqs/${id}`, request)
    return response.data
  }

  /**
   * Delete FAQ (admin endpoint)
   */
  async deleteFAQ(id: string): Promise<void> {
    await apiClient.delete(`/admin/faqs/${id}`)
  }
}

export const faqApi = new FAQApiService()

